import instance from 'utils/axiosConfig';

/**
 * 기기 삭제 API
 * @param {Object} [deviceId] - 기기 ID
 * @returns {Promise} API 응답 - 삭제 성공 여부
 */
export const deleteDevice = async (deviceId) => {
    try {
        const response = await instance.delete(`/api/v1/device/item/${deviceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
